import { gql } from "graphql-tag";

export const GET_SETTING = gql`
  query GetSetting {
    setting {
      id
      accountId
      country
      state
      announcementDeadlineMaintenance
      announcementDeadlineInspection
      canFollowUpAppointmentsSaturdays
      canFollowUpAppointmentsSundays
      canFollowUpAppointmentsHolidays
      intervalForInventoryEmails
      weekdaySelection
      hourForInventoryEmails
      minuteForInventoryEmails
      refillFluid
      createdAt
      updatedAt
    }
  }
`;
